import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';

import { formatToLocale } from '../../../utils/dates/dateMethods';

import { ALL_ELIGIBILITY_TYPES, APP_STATUSES } from '../../../constants/individualPortal/dashboard/dashboardModelTypes';
import AppStatusIndicator from '../../common/appStatusIndicator/AppStatusIndicator';

const AppInfo = (props) => {
    const {
        data,
        data: {
            applicationStatus,
            applicationType,
            financial,
            aptc,
            stateSubsidy,
            csr,
            primaryMember,
            esignDate
        },
        envData: {
            isState,
            language
        }
    } = props;

    const getEligibilities = (type, value) => {

        function getFormattedAmount(value) {
            return value === null ? <FormattedMessage id='common.not_eligible'/> :
                <Fragment>$<FormattedMessage id='household_section.eligibility.status.eligible_amount' values={{ amount: value.toFixed(2) }}/></Fragment>;
        }

        switch (type) {
            case ALL_ELIGIBILITY_TYPES.APTC:
            case ALL_ELIGIBILITY_TYPES.STATE_SUBSIDY:
                if (!financial) {
                    return <FormattedMessage id='common.financial_assistance_not_requested'/>;
                }

                return getFormattedAmount(value);

            case ALL_ELIGIBILITY_TYPES.CSR:
                return value === null ? <FormattedMessage id='common.not_eligible'/> : value;

            default:
                return value;
        }
    };

    const { ER, PN, EN, CL, DQ, OP, SU, SG, UC } = APP_STATUSES;
    const appStatusesGroup1 = [ ER, EN, PN, EN, CL];
    const appStatusesGroup2 =  [ ER, EN, PN, EN, CL, DQ];
    const appStatusesGroup3 =  [ OP, SU, SG, UC];


    const COLUMN_1 = [
        {
            id: 'common.app_status',
            component: <AppStatusIndicator appStatus={applicationStatus}/>,
            visibility: true
        },
        {
            id: 'common.coverage_year',
            propName: 'applicationYear',
            visibility: true
        },
        {
            id: 'common.type',
            component: <FormattedMessage id={applicationType}/>,
            visibility: true
        }
    ];

    const COLUMN_2 = [
        {
            id: 'common.primary_member',
            propName: 'primaryMember',
            visibility: Boolean(primaryMember)
        },
        {
            id: 'common.app_id',
            propName: 'caseNumber',
            visibility: !isState.MN
        },
        {
            id: 'common.case_id',
            propName: 'householdCaseId',
            visibility: true
        },
    ];

    const COLUMN_3 = [
        {
            id: 'common.date_created',
            propName: 'createdDate',
            visibility: true,
            format: true
        },
        {
            id: 'common.date_submitted',
            propName: 'esignDate',
            visibility: esignDate !== null && !appStatusesGroup3.includes(applicationStatus),
            format: true
        },
        {
            id: 'common.max_hh_aptc',
            component: getEligibilities(ALL_ELIGIBILITY_TYPES.APTC, aptc),
            visibility: appStatusesGroup1.includes(applicationStatus)
        },
        {
            id: 'common.max_hh_ss',
            component: getEligibilities(ALL_ELIGIBILITY_TYPES.STATE_SUBSIDY, stateSubsidy),
            visibility: stateSubsidy !== null && appStatusesGroup1.includes(applicationStatus)
        },
        {
            id: 'common.csr',
            component: getEligibilities(ALL_ELIGIBILITY_TYPES.CSR, csr),
            visibility: appStatusesGroup2.includes(applicationStatus)
        },
    ];
    
    const APP_INFO_TO_RENDER = [COLUMN_1, COLUMN_2, COLUMN_3];

    return (
        <div className='application__info'>
            {
                APP_INFO_TO_RENDER.map((column, index) => (
                    <ul key={index} className="application__info-list">
                        {column.map(({ id, propName, component, visibility, format }) =>  visibility && (
                            <li className="application__info-list__item" key={id}>
                                <p className="application__info-list__item__title">
                                    <FormattedMessage id={id}/>
                                </p>

                                { propName ?
                                    <p className="application__info-list__item__content">
                                        {format ? formatToLocale(data[propName], language) : data[propName]}
                                    </p> : component
                                }
                            </li>
                        ))}
                    </ul>
                ))
            }
        </div>
    );
};

export default AppInfo;
